import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TabSettings from "components/__new/common/TabSettings";
import Maybe from "components/__new/common/Maybe";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { BackButtonPage } from "components/__new/common/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateFormat, { monthNames } from "utils/dateFormat";
import { renderStatusColor, renderStatusText } from "utils/payroll/statusUI";
import PageContent from "components/__new/common/PageContent";
import { TransactionsListReadOnly } from "components/__new/payroll/runPayroll/TransactionsList-ReadOnly";
import * as payrollAction from "store/entities/payroll/runPayroll/action";


const Index = () => {
    const {id} = useParams();
    const dispatch = useDispatch();


    const { payrollLoading, payroll } = useSelector((s) => s.entities.runPayroll);
    

    const getPayrollDetails = () => {
        dispatch(payrollAction.getPayrollDetails(id));
    }


    useEffect(() => {
        if (id){
            getPayrollDetails();
        }
        // eslint-disable-next-line
    }, []);


    return (
        <div>


            <DynamicHeadTag
                headerText={id + " - Payroll History"}
                headerDescription=""
            />


            <div className="border-b">
                <TabSettings options={[
                    {
                        title: <span>Pay Run</span>,
                        type: "link",
                        url: `/payroll/${payroll?.id}/run`,
                        removeAutoActive: true,
                    },
                    {
                        title: <span>Payroll History</span>,
                        type: "link",
                        url: "/payroll/history",
                    },
                ]} />
            </div>


            <div className="mt-6 lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex items-center">
                        <BackButtonPage />
                        
                        <Maybe condition={payrollLoading === true}>
                            <FontAwesomeIcon icon="circle-notch" spin className="text-xl mr-2" /> Payroll
                        </Maybe>

                        <Maybe condition={payrollLoading === false}>
                            <div>
                                {monthNames[payroll?.schedule?.month -1] || "-"} {payroll?.schedule?.year} Payroll
                            </div>
                            
                            <div className="text-base font-normal hidden lg:block pl-6 ml-6 border-l border-gray-300">
                                Period:
                                <span className="ml-2 text-ep-secondary-600">
                                    {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                                    &nbsp;-&nbsp;
                                    {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                                </span>
                            </div>
                        </Maybe>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex flex-wrap items-center mt-4 lg:mt-0 lg:justify-end">

                    <Maybe condition={payrollLoading === false}>
                        <div className="lg:hidden mr-4">
                            Period:
                            <span className="ml-2 text-ep-secondary-600">
                                {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                                &nbsp;-&nbsp;
                                {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                            </span>
                        </div>

                        <label className={"label-parent " + renderStatusColor(payroll?.status)}>
                            <label className="label-child">
                                {payroll?.status}
                            </label>
                            <span className="text-ep-primary-700 font-medium">
                                {renderStatusText(payroll?.status)}
                            </span>
                        </label>
                    </Maybe>

                </div>
            </div>


            <PageContent
                loading={payrollLoading}
                data={payroll?.id}
                classes="mt-6 box"
                loadingText="Loading payroll data"
                emptyText="Payroll data not found"
                errorText="Unable to load payroll data"
            />


            <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>
                <div className="mt-6 py-6 border-t border-gray-200">
                    <div className="w-full sm:flex sm:justify-between items-center">
                        <div>
                            <span className="font-medium text-xl">Payment Details</span>
                        </div>
                        <div>
                            
                        </div>
                    </div>
                </div>


                <div className="pt-6 mt-0 space-y-6 sm:flex sm:space-x-8 sm:space-y-0 md:block md:space-x-0 md:space-y-6 lg:flex lg:space-x-8 lg:space-y-0 sm:justify-between border-t border-gray-200">
                    <div className="sm:w-1/2 md:w-full lg:w-1/2 box">
                        <div className="text-fade-dark text-lg font-medium">
                            Initiated By:
                        </div>
                        <div className="pt-4 mt-4 font-medium text-lg border-t border-gray-200">
                            -
                        </div>
                    </div>
                    <div className="sm:w-1/2 md:w-full lg:w-1/2 box">
                        <div className="text-ep-primary text-lg font-medium">
                            Approved By:
                        </div>
                        <div className="pt-4 mt-4 font-medium text-lg border-t border-gray-200">
                            {payroll?.approver || "-"}
                        </div>
                    </div>
                </div>


                <div className="mt-6">
                    <TransactionsListReadOnly
                        payroll={payroll}
                    />
                </div>
            </Maybe>


        </div>
    )
}


export default Index;